import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appCardHeaderContainer]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppCardHeaderContainerDirective {
  class = input<string>();

  #base = 'flex items-center justify-start gap-3 p-4';

  public styles = computed(() => cn(this.#base, this.class()));
}
